export default __webpack_public_path__ + "static/media/item_1@3x.d24c60b0.png";